import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { Box, Typography, Button, Stack } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import CardListStep3 from "../Components/CardListStep3";
import { guestAllocation } from "../actions";
import LoadingOverlay from "../Components/Loading/LoadingOverlay";
import { Modal } from "react-bootstrap";

const { URL_PREFIX } = window;

const VF1Step3 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [userData, setUserData] = useState([]);
  const history = useHistory();
  const getLocalStorage = () => {
    const localStorageData = JSON.parse(
      localStorage.getItem("@wakatobi-allocation")
    );

    setUserData(localStorageData);
  };
  useEffect(() => {
    getLocalStorage();
  }, []);

  const onHandleConfirm = async () => {
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    const roomAllocationData = userData.map((v) => {
      return {
        Id: v.Id,
        Remarks__c: v.Remarks__c,
      };
    });

    let segments = [];
    userData.forEach((room) => {
      room.segments &&
        room.segments.forEach((segment) =>
          segments.push({
            Id: segment.Id,
            Room_Allocation__c: segment.Room_Allocation__c,
          })
        );
    });

    const data = {
      roomAllocation: roomAllocationData,
      segment: segments,
    };
    try {
      await guestAllocation(data);
      setSuccessMessage('Data successfully updated!');

    } catch (error) {
      setErrorMessage('Error during guest allocation: ' + error.message);
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        setSuccessMessage(null);
        history.push(`${URL_PREFIX}/vf1/wizard/summary`);
      }, 3000);
    }
  };

  const getFilterBySegmentType = (data, type) => {
    const roomAllocation = data.filter((data) => {
      if (type === "Others") {
        if (!data.segments || data.segments.length === 0) {
          return true;
        }
      }
      if (data.segments && data.segments.length > 0) {
        return data.segments[0].Segment_Type__c === type;
      }
      return false;
    });
    return roomAllocation;
  };

  return (
    <>
      <Modal show={!!errorMessage} onHide={() => setErrorMessage(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setErrorMessage(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!successMessage} onHide={() => setSuccessMessage(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{successMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setSuccessMessage(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingOverlay
        isLoading={isLoading}
      />

      <div style={{ margin: "30px" }}>
        <Box sx={{ width: "auto" }}>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "30px" }}>
            Confirmation
          </Typography>
        </Box>
        <Box sx={{ width: "auto", marginTop: "10px" }}>
          <Typography
            variant="text-large"
            sx={{
              color: "#667085",
              fontSize: "18px",
              fontWeight: 300,
            }}>
            Please confirm if the room assigned and other details are correct
          </Typography>
        </Box>

        <CardListStep3
          getFilterBySegmentType={getFilterBySegmentType}
          userData={userData}
          segmentType="Resort"
        />

        <CardListStep3
          getFilterBySegmentType={getFilterBySegmentType}
          userData={userData}
          segmentType="Pelagian"
        />

        <CardListStep3
          getFilterBySegmentType={getFilterBySegmentType}
          userData={userData}
          segmentType="Others"
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
          }}>
          <Stack direction="row" gap={4}>
            <Link
              to={`${URL_PREFIX}/vf1/wizard/guest-allocation`}
              style={{ textDecoration: "none" }}>
              <Button
                sx={{
                  padding: "12px 20px",
                  width: "77px",
                  height: "48px",
                  background: "#FFFFFF",
                  border: "1px solid #D0D5DD",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  borderRadius: "8px",
                }}>
                <Typography
                  sx={{ color: "#344054", fontWeight: 600, fontSize: "16px" }}>
                  Back
                </Typography>
              </Button>
            </Link>

            {/* <Link
              to={`${URL_PREFIX}/vf1/wizard/summary`}
              style={{ textDecoration: "none" }}> */}
            <Button
              onClick={onHandleConfirm}
              disabled={isLoading == true}
              sx={{
                padding: "12px 20px",
                width: "auto",
                height: "48px",
                background: "#2F37B5",
                border: "1px solid #D0D5DD",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                borderRadius: "8px",
                ":hover": {
                  background: "#2F37B5",
                },
              }}>

              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 600,
                  fontSize: "16px",
                }}>
                Confirm
              </Typography>

            </Button>
            {/* </Link> */}
          </Stack>
        </div>
      </div>
    </>
  );
};
VF1Step3.propTypes = {
  vf1: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Step3);
